import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { ColorTokens as t } from "@vds-tokens/color";
import { calculateRem as n } from "@vds-core/utilities";
import r from "styled-components";
var o = {
    size: "medium",
    surface: "light",
    ariaHidden: !1,
    title: void 0
  },
  l = r.svg.withConfig({
    displayName: "StyledSVG",
    componentId: "VDS__sc-3zla24-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref) {
    var i = _ref.$iconHeight;
    return n(i);
  }, function (_ref2) {
    var i = _ref2.$iconWidth;
    return n(i);
  }, function (_ref3) {
    var i = _ref3.$iconHeight;
    return n(i);
  }, function (_ref4) {
    var i = _ref4.$iconWidth;
    return n(i);
  }),
  a = function a(i) {
    switch (i) {
      case "XLarge":
        return 28;
      case "large":
        return 24;
      case "small":
        return 16;
      case "medium":
        return 20;
      default:
        return i || 20;
    }
  },
  c = function c(n) {
    var r = n.ariaHidden,
      o = n.size,
      c = n.id,
      d = n.name,
      u = n.viewBox,
      s = n.color,
      m = n.svgContent,
      h = n.title,
      f = n.ariaLabel,
      g = null != s ? s : t.elements.primary.onlight.value,
      p = f || "".concat(d, " icon");
    return i(l, {
      id: c,
      role: "img",
      "aria-hidden": r,
      "aria-label": p,
      "alt-text": p,
      $iconWidth: a(o),
      $iconHeight: a(o),
      viewBox: u,
      fill: g,
      children: [!r && h && e("title", {
        children: h
      }), m]
    });
  };
c.defaultProps = o;
export { c as default, o as defaultProps };